import { render, staticRenderFns } from "./CollectionCreatorNoItemsMessage.vue?vue&type=template&id=ea8b77b8"
import script from "./CollectionCreatorNoItemsMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCreatorNoItemsMessage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports